import Vue from "vue";
Vue.filter("nutFilter", (value) => {
  value == "quantityHeat"
    ? (value = "热量")
    : value == "protein"
    ? (value = "蛋白质")
    : value == "fat"
    ? (value = "脂肪")
    : value == "carbohydrate"
    ? (value = "碳水化合物")
    : value == "sodium"
    ? (value = "钠")
    : value == "dietaryFiber"
    ? (value = "膳食纤维")
    : "";
  return value;
});
